export enum TeamsRespondType {
    Reply = 'Reply',
    ReplyAll = 'ReplyAll',
}
